import { apiRequest } from "../../Timetable/utils/http.js";

// Persistence for a single campus+date rota. Backend contract:
// docs/backend-ticket-daily-rota.md. Gracefully treats "no saved rota yet"
// (404 / 204 / empty) as null so the caller falls back to the seed.
export async function getDailyRota(campus, date) {
  const params = new URLSearchParams({ campus, date });
  try {
    const data = await apiRequest(`api/daily-rota?${params.toString()}`);
    return data && data.blocks ? data : null;
  } catch (e) {
    if (e && e.status === 404) return null;
    throw e;
  }
}

export async function saveDailyRota({ campus, date, blocks }) {
  return apiRequest(`api/daily-rota`, {
    method: "PUT",
    body: { campus, date, blocks },
  });
}
